export default defineNuxtRouteMiddleware(async (to, from) => {
  const toPath = to.fullPath.replace(/^\/+/, '').split('#')[0]
  if (!toPath || toPath === '/') {
    return navigateTo('/es')
  }
})
